import {OnInit} from '@angular/core';
import {BodyService} from './body.service';
import {NotificationService} from '../../core/services/notification.service';
import {JsonApiService} from '../../core/api/json-api.service';
import {config} from '../smartadmin.config';
import {HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Router} from '@angular/router';
import {presets} from '../graphs/chart-js/chart-js.presets';

declare var Chart:any;
declare var $: any;


export class BaseGeneral implements OnInit {

    protected datai18n: any ;
    protected numeroMaximoRecientes: number= 5;
    protected rutaServidor = localStorage.getItem('rutaServidor');

    protected listaBusqueda: any;
    protected posicionActualListaBusqueda : number;
    protected flagBotonesAnteriorSiguiente: boolean = false;

    public iconPantalla: string;
    public urlPantalla: string;
    public urlPantallaCrud: string;
    public tituloPantalla: string;
    public codigoPantalla: string;
    public accion: string;
    public idString: string;
    public iconCrud: string;
    public flagAccion: string;
    public styleModalCrud : string = "modal-md";
    public flagPopupCrud: boolean = false;
    public flagEsNuevo : boolean = false;
    public flagEsModificar : boolean = false;
    public flagEsLectura : boolean = false;
    public flagLoading: boolean = true;
    public widthGrillaList = 100;
    public widthAnchoColLabelCrudPopup = "col-4";
    public widthAnchoColInputCrudPopup = "col-8";
    public graphVacio: any = {
        "line-chart": {},
        "radar-chart": {},
        "polar-chart": {},
        "bar-chart":{},
        "doughnut-chart":{},
        "pie-chart": {}
    };


    public optionsButton = {
        "colReorder": true,
        "dom": "Bfrtip",
        "lengthMenu": [[10, 20, 25, 50, 100, -1], [10, 20, 25, 50, 100, "Todos"]],
        "buttons": [
            {
                extend: 'copyHtml5',
                text: '<i class="fa fa-files-o fa-lg"></i>',
                titleAttr: 'Copy',
                exportOptions: {
                    columns: [1, 2, 3]
                }
            },
            {
                extend: 'excel',
                text: '<i class="fa fa-file-excel-o fa-lg"></i>',
                titleAttr: 'Excel',
                exportOptions: {
                    columns: [1, 2, 3]
                }
            },
            {
                extend: 'csvHtml5',
                text: '<i class="fa fa-file-text-o fa-lg "></i>',
                titleAttr: 'CSV',
                exportOptions: {
                    columns: [1, 2, 3]
                }
            },
            {
                extend: 'pdfHtml5',
                text: '<i class="fa fa-file-pdf-o  fa-lg text-danger"></i>',
                titleAttr: 'PDF',
                exportOptions: {
                    columns: [1, 2, 3]
                }
            },
            {
                extend: 'colvis',
                text: '<i class="fa fa-tasks fa-lg"></i>',
                titleAttr: 'Columnas',
                exportOptions: {
                    columns: [1, 2, 3]
                }
            }
        ]
    };


    constructor(protected router : Router,
                protected bodyService: BodyService,
                protected notificationService: NotificationService,
                protected jsonApiService: JsonApiService
    ) {
        let data = localStorage.getItem("datai18n");
        this.datai18n = JSON.parse(data);
        // debugger;
        this.verificarSessionExpirada();

    }

    protected setOnConstructor() {}


    ngOnInit() {
        this.actualizarListaRecientes();
    }


    protected verificarSessionExpirada() {
        if (sessionStorage.getItem('expiracion')) {
            let expiracion = sessionStorage.getItem('expiracion');
            if (expiracion == 'S') {
                this.bodyService.showPopupSessionExpirada();
            }
        }
    }


    public obtenerObjeto(dt: string) {
        //// debugger;
        let id = '#' + dt;
        var objeto = $(id);
        return objeto;
    }

    public setearObjeto(dt:string) {
        let inputCampo = this.obtenerObjeto(dt);
        let valor = inputCampo[0].value;
        return valor;
    }

    protected onSubmit(form: string, btnCerrar: string) {
        // debugger;

        let nameForm = "#" + form;
        let formObject = $(nameForm);
        formObject.data('bootstrapValidator').validate();
        let validarForm: boolean = formObject.data('bootstrapValidator').isValid();
        if  (!validarForm) {
            return;
        }
        if (this.setValidarSubmit()) {
            // debugger;
            this.flagLoading = true;
            this.setOnSubmit().subscribe( data=>{
                    // debugger;

                    switch (this.flagAccion) {
                        case "N":
                            this.mostrarMensajeInsertarOK();
                            break;
                        case "M":
                            this.mostrarMensajeModificarOK();
                            break;
                        case "E":
                            this.mostrarMensajeEliminarOK();
                            break;
                        default:
                            this.mostrarMensajeActualizarOK();
                    }
                    this.flagLoading = false;
                    this.actualizarListaRegistroOK(
                        this.tituloPantalla,
                        this.flagAccion,
                        this.accion + " - " + this.datai18n['registro.actualizado.ok'],
                        data
                    );

                    this.setAfterOnSubmit(data);
                    let botonCerrar = this.obtenerObjeto(btnCerrar);
                    botonCerrar.click();
                },
                error =>  {
                    // debugger;
                    this.actualizarListaRegistroError(
                        this.tituloPantalla,
                        this.flagAccion,
                        this.accion + " - " + error,
                        null
                    );

                }
            );
        }

    }

    protected setValidarSubmit(): boolean {
        return true;
    }

    /* Dicho metodo tiene que ser obligatoriamente sobreescrito para cuando actualice en BD */
    protected setOnSubmit():Observable<any> {
        return Observable.of("");;
    }

    protected setAfterOnSubmit(data: any) {

    }

    protected renderGraph(idchart: string, type: string, data: any){
        // debugger;
        let name = "#" + idchart;
        let gobject = $(name);
        let ctx = gobject[0].getContext("2d");
        if(data.datasets && data.datasets.length && presets[type] && presets[type].dataset){
            data.datasets =  data.datasets.map((it)=>{
                return Object.assign({}, presets[type].dataset, it)
            })
        }
        let chart = new Chart(ctx, {
            type: type,
            data: data,
            options: presets[type] ? presets[type].options : {}
        });
        chart.update();

    }

    public mostrarMensajeError(error: any) {
        this.notificationService.smallBoxError(error);
    }

    public mostrarMensajeInsertarOK() {
        this.notificationService.smallBoxOK(
            this.datai18n['registro.insertado.ok'],
            this.datai18n.cerrar5segundos);
    }

    public mostrarMensajeModificarOK() {
        this.notificationService.smallBoxOK(
            this.datai18n['registro.actualizado.ok'],
            this.datai18n.cerrar5segundos);
    }

    public mostrarMensajeEliminarOK() {
        this.notificationService.smallBoxOK(
            this.datai18n['registro.eliminado.ok'],
            this.datai18n.cerrar5segundos);
    }

    public mostrarMensajeActualizarOK() {
        this.notificationService.smallBoxOK(
            this.datai18n['registro.actualizado.ok'],
            this.datai18n.cerrar5segundos);
    }

    protected onSetSetearBeanCrud(dt: string, data: any):any {
        return null;
    }

    protected getBaseUrl(){
        return location.protocol + '//' + location.hostname + (location.port ? ':'+location.port : '') + '/'
    }

    protected getBaseAssetApi(){
        return config.API_URL;
    }

    protected limpiarValidar(idForm: string) {
        // debugger;
        try {
            let nameForm = "#" + idForm;
            let form = $(nameForm);
            form.data('bootstrapValidator').resetForm();
        }
        catch (e) {

        }
    }

    protected actualizarListaRecientes() {
        // debugger;
        let lista = sessionStorage.getItem("listaRecientes");
        let listaRecientes = JSON.parse(lista);
        if (listaRecientes == null) {
            listaRecientes = [];
        }
        let nuevo =   {
            icono: "",
            codigo: "",
            descripcion: "",
            url: ""
        };
        // debugger;
        nuevo.icono = this.iconPantalla;
        nuevo.codigo = this.codigoPantalla;
        nuevo.descripcion = this.tituloPantalla;
        nuevo.url = "#" + this.urlPantalla;
        if (listaRecientes.length <= 0) {
            listaRecientes.push(nuevo);
        }
        else {
            let listaDepurar: Array<any> = [];
            for (var item of listaRecientes) {
                if (item.descripcion != this.tituloPantalla) {
                    listaDepurar.push(item);
                }
            }
            listaRecientes = [];
            listaRecientes = listaDepurar;

            let listaNueva: Array<any> = [];
            let contador = 1;
            listaNueva.push(nuevo);
            for (var item of listaRecientes) {
                if (contador < this.numeroMaximoRecientes) {

                    listaNueva.push(item);
                }
                contador++;
            }
            listaRecientes = [];
            listaRecientes = listaNueva;
        }
        // debugger;
        sessionStorage.setItem("listaRecientes", JSON.stringify(listaRecientes));
        this.verificarSessionExpirada();
    }

    protected actualizarListaRegistroOK(opcion: string, flagAccion: string, descripcion: string, objectJson: any) {
        this.verificarSessionExpirada();
        this.actualizarListaSeguimiento(opcion, flagAccion, descripcion, null, false, objectJson);

    }

    protected actualizarListaRegistroError(opcion: string, flagAccion: string, error: any, objectJson: any) {
        this.verificarSessionExpirada();
        this.actualizarListaSeguimiento(opcion, flagAccion, null, error, true, objectJson);

    }

    protected actualizarListaSeguimiento(opcion: string, flagAccion: string, descripcion: string, error: any, esError: boolean, objectJson: any) {
        let nuevo: any =   {
            fecha: new Date(),
            pantalla: "",
            opcion: "",
            descripcion: "",
            color: "",
            icono: "file-text",
            url: "",
            data: null
        };
        let lista = sessionStorage.getItem("listaSeguimiento");
        let listaNueva = [];
        let listaSeguimiento = JSON.parse(lista);
        if (listaSeguimiento == null) {
            listaSeguimiento = [];
        }
        // debugger;
        nuevo.pantalla = this.tituloPantalla;
        nuevo.opcion = this.accion;
        nuevo.descripcion = descripcion;
        nuevo.url = "#" + this.urlPantalla;
        nuevo.data = JSON.stringify(objectJson);
        if (esError) {
            nuevo.descripcion = JSON.stringify(error);
        }
        else {
            nuevo.descripcion = descripcion;
        }
        if (this.accion != undefined) {
            switch (flagAccion) {
                case "B":
                    nuevo.icono = "search";
                    nuevo.color = "bg-color-yellow";
                    break;
                case "N":
                    nuevo.icono = "file-o";
                    nuevo.color = "bg-color-greenDark";
                    break;
                case "M":
                    nuevo.icono = "edit"
                    nuevo.color = "bg-color-greenDark"
                    break;
                case "C":
                    nuevo.icono = "file-text-o";
                    nuevo.color = "bg-color-greenDark";
                    break;
                case "E":
                    nuevo.icono = "trash-o";
                    nuevo.color = "bg-color-greenDark";
                    break;
                default:
                    nuevo.icono = "file-text";
                    nuevo.color = "bg-color-greenDark";
            }
            if (esError) {
                nuevo.color = "bg-color-redDark" ;
            }

            listaNueva.push(nuevo);
            if (listaSeguimiento != null) {
                for(var i=0; i < listaSeguimiento.length; i++) {
                    listaNueva.push(listaSeguimiento[i]);
                }

            }

            sessionStorage.setItem("listaSeguimiento", JSON.stringify(listaNueva));
        }


    }



}



// WEBPACK FOOTER //
// ./src/app/shared/_utils/BaseGeneral.ts